import { NS } from "../common/classes";

export const FLOATING_PHONE_INPUT = `${NS}-floating-phone-input`;
export const FLOATING_PHONE_INPUT_CONTAINER = `${FLOATING_PHONE_INPUT}-container`;
export const FLOATING_PHONE_INPUT_LABEL = `${FLOATING_PHONE_INPUT}-label`;
export const FLOATING_PHONE_INPUT_INVISIBLE = `${FLOATING_PHONE_INPUT}-invisible`;
export const FLOATING_PHONE_INPUT_FIXED_PLACEHOLDER = `${FLOATING_PHONE_INPUT}-fixed-placeholder`;
export const FLOATING_PHONE_INPUT_COUNTER = `${FLOATING_PHONE_INPUT}-counter`;
